<template>
  <div class="individuals-pricing-container">
    <div class="partner-statements-badge">Pricing</div>
    <div class="partner-individuals-title">Choose Your Perfect Plan</div>
    <div class="partner-individuals-desc">
      60 minutes long classes, live on Zoom with a native teacher.
    </div>
    <IndividualPricingPlans />
  </div>
</template>

<script>
import IndividualPricingPlans from "./IndividualPricingPlans.vue";

export default {
  name: "individualPricingCourses",
  components: {
    IndividualPricingPlans,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style></style>
